export function bem(base: string, ...modifiers: Array<string>): string {
  return [
    base,
    ...modifiers
      .filter(modifier => modifier !== null)
      .filter(modifier => typeof modifier !== 'undefined')
      .map(modifier => `${base}--${modifier}`)
  ].join(' ')
}

export function bemm(base: string, ...modifiers: Array<string>): string {
  return [
    ...modifiers
      .filter(modifier => modifier !== null)
      .filter(modifier => typeof modifier !== 'undefined')
      .map(modifier => `${base}--${modifier}`)
  ].join(' ')
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/bem.js